/* ============================================
   EGA HOME - Design System JavaScript
   Scroll Reveal Animations
   v2.0 - Feb 16 2026 - Cleaned up, uses Symmetry native header
   ============================================ */

(function() {
  'use strict';

  // === SCROLL REVEAL ANIMATION === //
  var observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.reveal-on-scroll').forEach(function(el) {
      observer.observe(el);
    });
  });

  // === HERO CROSSFADE (if multiple slides) === //
  document.addEventListener('DOMContentLoaded', function() {
    var hero = document.querySelector('[data-hero-crossfade-v3]');
    if (!hero) return;

    var slides = hero.querySelectorAll('.ega-hero-v3__slide');
    if (slides.length < 2) return;

    var current = 0;
    var interval = parseInt(hero.dataset.interval) || 6000;

    setInterval(function() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, interval);
  });
})();

/* === FAST NAV DROPDOWNS === */
/* Override Symmetry's 250ms navHoverDelay — keep small delay for usability */
(function() {
  'use strict';
  function setDelay() {
    var header = document.querySelector('#pageheader');
    if (!header) return;
    var all = header.querySelectorAll('*');
    all.forEach(function(el) {
      if (el.navHoverDelay !== undefined) {
        el.navHoverDelay = 50;
      }
    });
    /* Also keep dropdowns open while mouse is inside them */
    var dropdowns = header.querySelectorAll('.navigation__item--with-children');
    dropdowns.forEach(function(item) {
      var dropdown = item.querySelector('.navigation__tier-2-container');
      if (dropdown) {
        dropdown.addEventListener('mouseenter', function() {
          clearTimeout(parseInt(item.dataset.navCloseTimeoutId));
        });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    setDelay();
    setTimeout(setDelay, 100);
    setTimeout(setDelay, 500);
    setTimeout(setDelay, 1000);
  });
})();

/* ── EGA Cart Drawer: Add These Finishing Touches (Custom) ── */
(function() {
  'use strict';

  var LIMIT = 4;
  var running = false;
  var done = false;
  var lastCartKey = '';

  // Fallback mapping when room tags are missing
  var TYPE_TO_ROOMKEY = {
    'dining tables': 'dining-room',
    'round dining tables': 'dining-room',
    'dining chairs': 'dining-room',
    'sideboards': 'dining-room',
    'sideboards & buffets': 'dining-room',
    'buffets': 'dining-room',
    'bar cabinets': 'dining-room',
    'china cabinets': 'dining-room',
    'serving tables': 'dining-room',

    'sofas': 'living-room',
    'accent chairs': 'living-room',
    'coffee & cocktail tables': 'living-room',
    'coffee tables': 'living-room',
    'cocktail tables': 'living-room',
    'console tables': 'living-room',
    'end tables': 'living-room',
    'side tables': 'living-room',
    'bookcases': 'living-room',
    'media cabinets': 'living-room',
    'etageres': 'living-room',

    'desks': 'office',
    'desk chairs': 'office',
    'filing cabinets': 'office',

    'beds': 'bedroom',
    'nightstands': 'bedroom',
    'dressers': 'bedroom',
    'chests': 'bedroom',
    'chests of drawers': 'bedroom',
    'armoires': 'bedroom',

    'mirrors': 'any',
    'lamps': 'any',
    'chandeliers': 'any',
    'lighting': 'any'
  };

  // Style tags we actually use on PDP now
  var KNOWN_STYLES = [
    '18th Century','19th Century','20th Century','Art Deco','Georgian','Chippendale','Regency','Hollywood Regency',
    'Mid-Century Modern','Transitional','Organic Modern','Federal','Sheraton','Hepplewhite','Country','Rustic','Industrial','Neoclassical','Traditional','Modern','Farmhouse','Contemporary'
  ];
  var STYLE_SET = Object.create(null);
  KNOWN_STYLES.forEach(function(s){ STYLE_SET[s] = true; });

  // Anchor furniture types by room (strong complements)
  // Cart drawer rule: keep these "reasonable add-ons" (no giant casegoods like bookcases/beds/tables)
  var ANCHOR_TYPES = {
    'living-room': ['Coffee & Cocktail Tables','Side & End Tables','Accent Chairs','Console Tables','Mirrors','Ottomans and Poufs','Floor Lamps','Table Lamps'],
    'dining-room': ['Dining Chairs','Sideboards & Buffets','Bar Cabinets','Chandeliers','Bar Carts','Mirrors'],
    'bedroom': ['Nightstands','Benches','Mirrors','Table Lamps'],
    'office': ['Desk Chairs','Table Lamps','Mirrors'],
    'entryway': ['Console Tables','Mirrors','Center Tables','Lanterns','Benches']
  };

  // For cart drawer we DO want smaller add-ons to show up sometimes
  var DECOR_TYPES = [
    'Table Lamps','Floor Lamps','Sconces','Chandeliers','Lanterns',
    'Decorative Objects','Accessories','Candelabra','Mirrors'
  ];

  // Hard excludes for cart drawer (avoid suggesting huge pieces)
  var BLOCKED_TYPES = [
    'Sofas','Sectionals','Bookcases','Bookshelves & Etageres','Etageres',
    'Beds','Dining Tables','Dressers','Chest of Drawers','Armoires','Desks','Media Cabinets'
  ];
  var BLOCKED_SET = Object.create(null);
  BLOCKED_TYPES.forEach(function(t){ BLOCKED_SET[String(t).toLowerCase()] = true; });
  function isBlockedType(t) {
    var key = String(t || '').toLowerCase();
    if (!key) return false;
    if (BLOCKED_SET[key]) return true;
    // Catch common variants
    if (key.indexOf('bookcase') >= 0) return true;
    if (key.indexOf('sofa') >= 0) return true;
    if (key.indexOf('bed') >= 0 && key !== 'bedside tables') return true;
    return false;
  }

  function firstRoomTag(tags) {
    if (!tags || !tags.length) return '';
    for (var i=0;i<tags.length;i++) {
      if (typeof tags[i] === 'string' && tags[i].indexOf('room:') === 0) return tags[i];
    }
    return '';
  }

  function roomTagFromType(productType) {
    if (!productType) return '';
    var key = TYPE_TO_ROOMKEY[String(productType).toLowerCase()] || '';
    if (!key || key === 'any') return '';
    return 'room:' + key;
  }

  function styleTagsFromTags(tags) {
    var out = [];
    if (!tags || !tags.length) return out;
    for (var i=0;i<tags.length;i++) {
      var t = tags[i];
      if (STYLE_SET[t]) out.push(t);
    }
    return out;
  }

  function fetchSuggest(query) {
    var url = '/search/suggest.json?resources[type]=product&resources[limit]=10&resources[options][fields]=tag&q=' + encodeURIComponent(query);
    return fetch(url)
      .then(function(r){ return r.json(); })
      .then(function(d){
        return (d && d.resources && d.resources.results && d.resources.results.products) ? d.resources.results.products : [];
      });
  }

  function formatPrice(p) {
    var n = parseFloat(p || '0');
    if (!n || n <= 0) return 'Contact for Pricing';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function img300(src) {
    if (!src) return '';
    return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
  }

  function inject(picks) {
    if (!picks || picks.length < 2) return false;

    var html = '<div id="egaFBT" class="cart-drawer__content-item" style="padding:16px 20px;background:#FAF8F5;border-top:1px solid #E5E7EB;">';
    html += '<div style="font-size:12px;font-weight:600;letter-spacing:0.05em;text-transform:uppercase;color:#6B7280;margin-bottom:12px;">Add These Finishing Touches</div>';
    html += '<div style="display:grid;grid-template-columns:repeat(' + Math.min(picks.length, 4) + ',1fr);gap:10px;">';

    picks.forEach(function(p) {
      var href = (p.url || '').split('?')[0] || ('/products/' + (p.handle || ''));
      var price = formatPrice(p.price_min || p.price);
      var imgSrc = img300((p.featured_image && p.featured_image.url) || p.image || '');

      html += '<a href="' + href + '" style="text-decoration:none;color:inherit;text-align:center;display:block;">';
      html += '<div style="aspect-ratio:1;overflow:hidden;background:#fff;border:1px solid #E5E7EB;display:flex;align-items:center;justify-content:center;">';
      if (imgSrc) html += '<img src="' + imgSrc + '" alt="" style="width:100%;height:100%;object-fit:contain;padding:4px;" loading="lazy">';
      html += '</div>';
      html += '<div style="font-size:12px;font-weight:600;color:#374151;margin-top:6px;">' + price + '</div>';
      html += '</a>';
    });

    html += '</div></div>';

    var existing = document.getElementById('egaFBT');
    if (existing) existing.remove();

    var crossSell = document.querySelector('[data-merge="cross-sells"]');
    if (crossSell) { crossSell.innerHTML = html; return true; }

    var footer = document.querySelector('.cart-drawer__footer');
    if (footer && footer.parentNode) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      footer.parentNode.insertBefore(temp.firstChild, footer);
      return true;
    }

    var content = document.querySelector('.cart-drawer__content');
    if (content) { content.insertAdjacentHTML('beforeend', html); return true; }

    return false;
  }

  function run() {
    if (running) return;
    running = true;

    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart.items || !cart.items.length) { running = false; return; }

        var cartKey = cart.items.map(function(i){ return i.product_id; }).sort().join(',');
        if (cartKey === lastCartKey && done) { running = false; return; }
        lastCartKey = cartKey;

        var cartTypes = Object.create(null);
        cart.items.forEach(function(item){
          if (item.product_type) cartTypes[String(item.product_type).toLowerCase()] = true;
        });

        var first = cart.items[0];
        var handle = first.handle;
        if (!handle) { running = false; return; }

        fetch('/products/' + handle + '.json')
          .then(function(r){ return r.json(); })
          .then(function(d){
            var prod = d && d.product;
            if (!prod) { running = false; return; }

            var roomTag = firstRoomTag(prod.tags) || roomTagFromType(prod.product_type);
            if (!roomTag) { done = true; running = false; return; }

            var roomKey = roomTag.replace('room:','');
            var styles = styleTagsFromTags(prod.tags);
            var vendor = prod.vendor || '';
            var currentType = String(prod.product_type || '');

            var anchors = (ANCHOR_TYPES[roomKey] || []).slice();
            anchors = anchors.filter(function(t){ return String(t).toLowerCase() !== currentType.toLowerCase(); });

            var q1 = roomTag;
            var q2 = styles.length ? (styles[0] + ' ' + roomTag) : '';

            var reqs = [fetchSuggest(q1)];
            if (q2) reqs.push(fetchSuggest(q2));

            Promise.all(reqs).then(function(results){
              var seenIds = Object.create(null);
              var all = [];
              results.forEach(function(list){
                (list || []).forEach(function(p){
                  if (!p || !p.id) return;
                  if (seenIds[p.id]) return;
                  seenIds[p.id] = true;
                  all.push(p);
                });
              });

              var filtered = all.filter(function(p){
                if (!p.tags || !p.tags.length) return false;
                if (isBlockedType(p.type)) return false;
                if (cartTypes[String(p.type || '').toLowerCase()]) return false;
                // Ensure tag match (search can be fuzzy)
                var hasRoom = false;
                for (var i=0;i<p.tags.length;i++) { if (p.tags[i] === roomTag) { hasRoom = true; break; } }
                return hasRoom;
              });

              // Score
              filtered.forEach(function(p){
                var score = 0;

                var aIdx = anchors.indexOf(p.type);
                if (aIdx >= 0) score += (100 - aIdx);

                var dIdx = DECOR_TYPES.indexOf(p.type);
                if (dIdx >= 0) score += (60 - dIdx);

                if (vendor && p.vendor === vendor) score += 20;

                // Style match bonus
                if (styles.length && p.tags && p.tags.length) {
                  for (var s=0;s<styles.length;s++) {
                    for (var t=0;t<p.tags.length;t++) {
                      if (p.tags[t] === styles[s]) score += 10;
                    }
                  }
                }

                if (parseFloat(p.price_min || p.price || '0') > 0) score += 5;

                p._score = score;
              });

              filtered.sort(function(a,b){ return (b._score||0) - (a._score||0); });

              // Pick: 2 anchors + 2 decor if available, fill the rest
              var picks = [];
              var usedTypes = Object.create(null);

              function take(predicate, max){
                for (var i=0;i<filtered.length && picks.length < LIMIT && max>0;i++) {
                  var p = filtered[i];
                  var t = p.type;
                  if (!t || usedTypes[t]) continue;
                  if (!predicate(p)) continue;
                  usedTypes[t] = true;
                  picks.push(p);
                  max--;
                }
              }

              take(function(p){ return anchors.indexOf(p.type) >= 0; }, 2);
              take(function(p){ return DECOR_TYPES.indexOf(p.type) >= 0; }, 2);
              take(function(){ return true; }, LIMIT);

              inject(picks);
              done = true;
              running = false;
            }).catch(function(e){ console.log('FBT suggest error:', e); running = false; });
          })
          .catch(function(e){ console.log('FBT product error:', e); running = false; });
      })
      .catch(function(e){ console.log('FBT cart error:', e); running = false; });
  }

  document.addEventListener('dispatch:cart-drawer:open', function(){
    done = false;
    setTimeout(run, 300);
  });

  document.addEventListener('on:cart:change', function(){
    done = false;
    lastCartKey = '';
    setTimeout(run, 500);
  });

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer, .js-cart-drawer');
    if (!drawer) return;

    var obs = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if (m.type === 'attributes' && (m.attributeName === 'open' || m.attributeName === 'class')) {
          var isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-open') || drawer.classList.contains('active');
          if (isOpen && !done) setTimeout(run, 300);
        }
      });
    });

    obs.observe(drawer, { attributes: true, attributeFilter: ['open','class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();

